import React, { useState } from "react";

import { ChatType } from "@api/graphql/types-and-hooks";
import { ExpertChatDetail } from "@pages/FronteraClarity/components/ExpertChatDetail";
import { ExpertChatSidePanel } from "@pages/FronteraClarity/components/ExpertChatSidePanel";
import { useBreakpoint } from "@pages/VideoSessionsV2/hooks/useMediaMatcher";

export const ExpertChatPage: React.FC = () => {
  const [selectedChat, setSelectedChat] = useState<ChatType>();
  const { isMobile } = useBreakpoint();

  if (isMobile) {
    return (
      <div className="fixed inset-0 top-[65px] bg-white">
        {!selectedChat ? (
          <ExpertChatSidePanel selectedChat={selectedChat} setSelectedChat={setSelectedChat} />
        ) : (
          <ExpertChatDetail chat={selectedChat} setSelectedChat={setSelectedChat} />
        )}
      </div>
    );
  }

  return (
    <div className="flex flex-row gap-2 -mx-10 -mb-8 mt-4 h-[calc(100vh-100px)] overflow-hidden">
      <ExpertChatSidePanel selectedChat={selectedChat} setSelectedChat={setSelectedChat} />

      {selectedChat && (
        <div className="flex flex-col gap-2 flex-1 min-w-0 h-full">
          <ExpertChatDetail chat={selectedChat} />
        </div>
      )}
    </div>
  );
};
